import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import History from "@/pages/History";
import Enquiries from "@/pages/Enquiries";
import ForgotPassword from "@/pages/ForgotPassword";
import Sketch from "@/pages/Sketch";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import PaymentResult from "@/pages/PaymentResult";
import Account from "@/pages/Account";
import { PaywallProvider } from "@/context/PaywallContext";
import Footer from "@/components/Footer";
import SeoLanding, { SEO_LANDINGS } from "@/pages/SeoLanding";
import { SeoManager } from "@/components/SeoManager";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PaywallProvider>
          <ScrollToTop />
          <SeoManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            {SEO_LANDINGS.map((r) => <Route key={r} path={r} element={<SeoLanding />} />)}
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentResult cancelled /></ProtectedRoute>} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sketch"
              element={
                <ProtectedRoute>
                  <Sketch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/enquiries"
              element={
                <ProtectedRoute>
                  <Enquiries />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" />
          </PaywallProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
